import { Canvas } from 'fabric';
import { Composition } from '../timeline/types';
import { usePlayheadDriver } from './playhead-driver';
import { useVideoSync } from './video-sync';
import { useAudioSync } from './audio-sync';

type UsePlaybackEngineOptions = {
  canvas: Canvas | null;
  composition: Composition;
  isPlaying: boolean;
  volume: number;
  muted: boolean;
  onEnd: () => void;
};

/**
 * Wires the playhead RAF clock, video sync, and audio sync into a single mount
 * point. Lives inside <PlaybackProvider> so playback works as soon as the
 * provider is on the tree (no need for consumers to mount it themselves).
 */
export const usePlaybackEngine = ({
  canvas,
  composition,
  isPlaying,
  volume,
  muted,
  onEnd
}: UsePlaybackEngineOptions): void => {
  usePlayheadDriver({ duration: composition.duration, isPlaying, onEnd });
  useVideoSync({ canvas, composition, isPlaying });
  useAudioSync({ composition, isPlaying, volume, muted });
};
